import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientContentContainer = memo((props: PropsWithChildren) => {
  return <View style={styles.container}>{props.children}</View>;
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['2'],
  },
});
